// extracted by mini-css-extract-plugin
export default {"csCategory":"FaqCategory_csCategory__ciiId","csCateBtn":"FaqCategory_csCateBtn__DNGfs","csCateActive":"FaqCategory_csCateActive__t4eep"};